import { apiClient as api } from "./httpClient";

/** vigente | futuro | encerrado — calculado das datas, não armazenado. */
export type ClinicPeriodSituation = "vigente" | "futuro" | "encerrado";

export interface ClinicPeriodRow {
  id: string;
  title: string;
  initialDate: string | null;
  finalDate: string | null;
  situation: ClinicPeriodSituation;
  active: boolean;
  /** Quantos objetivos apontam para este período — impede excluir o que está em uso. */
  goalsCount: number;
}

export interface SaveClinicPeriodPayload {
  id?: string;
  title: string;
  initialDate: string;
  finalDate: string;
}

export const clinicPeriodsService = {
  getAll: async (includeInactive = false): Promise<ClinicPeriodRow[]> => {
    const response = await api.get(`/clinic-periods`, { params: { includeInactive } });
    return response.data.items;
  },

  save: async (payload: SaveClinicPeriodPayload): Promise<string> => {
    const response = await api.post(`/clinic-periods`, payload);
    return response.data.id as string;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/clinic-periods/${id}`);
  },
};
